var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4547_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41666 9.58333C5.41666 11.7935 6.29463 13.9131 7.85743 15.4759C9.42024 17.0387 11.5399 17.9167 13.75 17.9167C15.9601 17.9167 18.0797 17.0387 19.6425 15.4759C21.2053 13.9131 22.0833 11.7935 22.0833 9.58333C22.0833 7.3732 21.2053 5.25358 19.6425 3.69078C18.0797 2.12797 15.9601 1.25 13.75 1.25C11.5399 1.25 9.42024 2.12797 7.85743 3.69078C6.29463 5.25358 5.41666 7.3732 5.41666 9.58333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 38.75V34.5833C1.25 32.3732 2.12797 30.2536 3.69078 28.6908C5.25358 27.128 7.3732 26.25 9.58333 26.25H17.9167C20.1268 26.25 22.2464 27.128 23.8092 28.6908C25.372 30.2536 26.25 32.3732 26.25 34.5833V38.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 1.52148C30.1259 1.98044 31.7147 3.02294 32.8493 4.48463C33.9838 5.94632 34.5997 7.74405 34.5997 9.5944C34.5997 11.4448 33.9838 13.2425 32.8493 14.7042C31.7147 16.1659 30.1259 17.2084 28.3333 17.6673",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75 38.75V34.5833C38.7394 32.7441 38.1207 30.96 36.9901 29.5092C35.8596 28.0583 34.2809 27.0223 32.5 26.5625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4547_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientDetail);
export default __webpack_public_path__ + "static/media/client-detail.210446bf6c3a4103ebd5bee0bc64ec48.svg";
export { ForwardRef as ReactComponent };